import { render } from "./Authenticated.vue?vue&type=template&id=721c757c"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"
script.render = render

export default script